import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHasChanges } from "../../../Store/Gmb/gmbProfileSlice";

const EditableTextArea = ({ initialData = "", onUpdate }) => {
  const [inputValue, setInputValue] = useState("");
  const [originalValue, setOriginalValue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    // Split initial data into lines and take the first 5
    const lines = initialData
      ? initialData
          .split(",")
          .slice(0, 5)
          .map((item) => item?.trim())
      : [];
    const initialString = lines.join("\n");
    setInputValue(initialString);
    setOriginalValue(initialString);
  }, [initialData]);

  const handleInputChange = (e) => {
    const lines = e.target.value.split("\n");
    if (lines.length <= 5) {
      const newValue = e.target.value;
      setInputValue(newValue);
      dispatch(setHasChanges(newValue.trim() !== originalValue.trim()));
    }
  };

  const handleBlur = () => {
    const updatedLabels = inputValue?.split("\n").slice(0, 5);
    onUpdate(updatedLabels.join(",")); // Update as a comma-separated string
  };

  return (
    <textarea
      className="	border-none rounded-md p-1
    	 text-black bg-[#F1F6FA]  text-sm
    	 "
      rows={5}
      style={{
        maxHeight: "80px",
        overflowY: "auto",
        resize: "none",
        scrollbarWidth: "2px",
      }}
      value={inputValue}
      onChange={handleInputChange}
      onBlur={handleBlur}
      placeholder="Edit labels..."
    />
  );
};

export default EditableTextArea;
